export default "__VITE_ASSET__CaauNkGL__"